import { Autosave, BlockQuote, Bold, ClassicEditor, Essentials, Italic, Link, List, Paragraph } from 'ckeditor5';

export default class Editor {
    constructor(element) {
        ClassicEditor.create(element, {
            toolbar: ['bold', 'italic', 'link', 'bulletedList', 'numberedList', 'blockQuote'],
            plugins: [
                Autosave,
                Essentials,
                Bold,
                Italic,
                Link,
                List,
                Paragraph,
                BlockQuote,
            ],
            licenseKey: 'GPL',
        });
    }

    static initAll(selector) {
        Array.from(document.querySelectorAll(selector), (element) => new Editor(element));
    }
}
